'use client'

import { TNotice } from '@/entities/support'
import { UserType } from '@/entities/user'
import { useFormatDate } from '@/shared/lib'
import { Layout, Separator } from '@/shared/ui'

import { Content } from '../content'
import { Header } from '../header'
import { Navigation } from '../navigation'

type Props = {
  userType: UserType
  notice: TNotice
}

export const NoticeDetail = ({ userType, notice }: Props) => {
  const { formatDate } = useFormatDate()

  return (
    <Layout className="mt-0 mb-15 flex flex-col">
      <Header
        userType={userType}
        title={notice.title}
        createdAt={formatDate({ date: notice.writeDate })}
      />
      <Separator color="black" />
      <Content contents={notice.contents} />
      <Separator color="black" />
      <Navigation
        userType={userType}
        previous={notice.previous}
        next={notice.next}
      />
    </Layout>
  )
}
